import { type Medium } from '@prisma/client';

/**
 * Resolve the display title of a medium based on the current locale.
 * Falls back to the other language's title, then to the medium name.
 */
export function getMediumTitle(medium: Pick<Medium, 'name' | 'titleEn' | 'titleDe'>, locale: string): string {
    if (locale === 'de') {
        return medium.titleDe ?? medium.titleEn ?? medium.name;
    }
    return medium.titleEn ?? medium.titleDe ?? medium.name;
}

/**
 * Resolve the examples/description of a medium based on the current locale.
 * Falls back to the other language's examples, then to undefined.
 */
export function getMediumExamples(
    medium: Pick<Medium, 'examplesEn' | 'examplesDe'>,
    locale: string,
): string | undefined {
    if (locale === 'de') {
        return medium.examplesDe ?? medium.examplesEn ?? undefined;
    }
    return medium.examplesEn ?? medium.examplesDe ?? undefined;
}
